import DropdonwItem from "./DropdownItem";
import DropdownMenu from "./DropdownMenu";
import DropdownRoot from "./DropdownRoot";

const Dropdown = { Item: DropdonwItem, Root: DropdownRoot, Menu: DropdownMenu };
export default Dropdown;
